import Image from 'next/image';

import { Section, SectionHeader } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const ArrowImage = ({ alt, imageName }) => (
  <Image
    alt={alt}
    fill
    style={{ objectFit: 'contain' }}
    src={`${staticMediaStoreBaseURL}/about-hafla/customers-business-partners/${imageName}.svg`}
  />
);

const FeatureCardImage = ({ alt, imageName }) => (
  <div className='rounded-xl overflow-hidden'>
    <Image
      alt={alt}
      height={312}
      width={392}
      style={{
        objectFit: 'cover',
        width: '392px',
        height: '312px'
      }}
      src={`${staticMediaStoreBaseURL}/about-hafla/customers-business-partners/${imageName}.png`}
    />
  </div>
);

const Description = ({ descriptionText }) => (
  <div className='text-white text-base mt-6 md:h-36'>{descriptionText}</div>
);

const ConnectAIButton = ({ buttonText }) => (
  <button className='mt-6 w-full bg-white text-brand font-bold py-2 px-2 rounded-lg flex items-center justify-center space-x-2'>
    <span>{buttonText}</span>
    <span className='text-lg'>→</span>
  </button>
);

const FeatureCards = () => (
  <div className='flex items-center justify-around min-h-screen bg-gray-50 p-4 font-Montserrat'>
    <div className='grid grid-cols-1 md:grid-cols-2 gap-y-28 md:gap-y-0 md:gap-x-52'>
      <div className='relative'>
        <div className='absolute -bottom-20 md:hidden'>
          <div className='relative w-40 h-28'>
            <ArrowImage
              {...{
                alt: 'customers-arrow-mobile',
                imageName: 'customers-arrow-mobile'
              }}
            />
          </div>
        </div>

        <div className='hidden md:block absolute -top-10 -right-28'>
          <div className='relative w-36 h-32'>
            <ArrowImage
              {...{
                alt: 'customers-arrow',
                imageName: 'customers-arrow'
              }}
            />
          </div>
        </div>

        <div className='p-4 rounded-2xl shadow-2xl bg-brand-gradient max-w-sm'>
          <FeatureCardImage
            {...{
              alt: 'Celebrities on a red carpet',
              imageName: 'customers'
            }}
          />
          <Description
            descriptionText='Bring your vision. We’ll shape it, price it, and deliver it with
              joyful precision—from C-suite dinners to family days and weddings.
              Start planning by chatting with Heba, our AI planner.'
          />
          <ConnectAIButton buttonText='Plan With Hafla AI✨' />
        </div>
      </div>

      <div className='relative'>
        <div className='absolute -top-20 -right-0 md:hidden'>
          <div className='relative w-40 h-28'>
            <ArrowImage
              {...{
                alt: 'business-partners-title-mobile',
                imageName: 'partners-arrow-mobile'
              }}
            />
          </div>
        </div>

        <div className='hidden md:block absolute -bottom-0 -left-28'>
          <div className='relative w-32 h-36'>
            <ArrowImage
              {...{
                alt: 'business-partners-title',
                imageName: 'partners-arrow'
              }}
            />
          </div>
        </div>

        <div className='p-4 rounded-2xl shadow-2xl bg-brand-gradient max-w-sm'>
          <FeatureCardImage
            {...{
              alt: 'A firm business handshake',
              imageName: 'business-partners'
            }}
          />
          <Description
            descriptionText='Join the UAE’s most active events marketplace. Win more business
              with structured briefs, faster approvals, predictable payments,
              and feedback loops that elevate your craft. Visit our Partner page
              to apply to list your venue or services.'
          />
          <ConnectAIButton
            {...{
              buttonText: 'Meet Sara - Your Onboarding Expert✨'
            }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default function CustomersPartners() {
  return (
    <>
      <Section>
        <SectionHeader
          gradientText='Customers & Business Partners'
          text='For'
        />
        <FeatureCards />
      </Section>
      <div className='border-t border-pink-100' />
    </>
  );
}
